<script setup lang="ts">
defineOptions({
	name: 'IconClockTime',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		:class="[props.class, props.classIcon]"
		viewBox="0 0 31 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M26.6802 17.2661C25.728 22.9152 20.6823 26.9463 14.9624 26.6276C9.24243 26.3089 4.67577 21.7422 4.35707 16.0223C4.03836 10.3023 8.06943 5.25662 13.7186 4.30444"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M26.135 11.4724C26.3815 12.1347 26.5645 12.8189 26.6815 13.5158"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M24.2667 8.21861C23.8156 7.67243 23.3135 7.17038 22.7673 6.71924"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.5134 4.85225C18.8513 4.60518 18.1671 4.42178 17.4701 4.30452"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M20.5126 15.9642H15.0215V9.22266"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
